export const stepsArray = [
  {
    step: 'Paso 1',
    label: 'Seleccionar usuarios',
  },
  {
    step: 'Paso 2',
    label: 'Asignar actividades',
  }
]

export const initialTable = {
  column: [],
  row: [],
} as any
